var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from "react";
import { StylesProvider } from "@material-ui/styles";
import { ThemeProvider } from "@material-ui/styles";
import QuizImpl from "./QuizImpl";
import { Provider } from "react-redux";
import { createStoreCreator } from "../state/store";
import quizzesTheme from "../themes";
import { initialize } from "../state/actions";
import { useEffect, useState } from "react";
var Quiz = function Quiz(props) {
  var _a = useState(null),
    store = _a[0],
    setStore = _a[1];
  var id = props.id,
    languageId = props.languageId,
    accessToken = props.accessToken,
    backendAddress = props.backendAddress,
    fullInfoWithoutLogin = props.fullInfoWithoutLogin,
    showZeroPointsInfo = props.showZeroPointsInfo;
  useEffect(function () {
    var newStore = createStoreCreator();
    var initializeAction = initialize(id, languageId, accessToken, backendAddress, fullInfoWithoutLogin, showZeroPointsInfo);
    newStore.dispatch(initializeAction);
    setStore(newStore);
  }, [id, languageId, accessToken, backendAddress, fullInfoWithoutLogin, showZeroPointsInfo]);
  if (!store) {
    return null;
  }
  return React.createElement(Provider, {
    store: store
  }, React.createElement(StylesProvider, {
    injectFirst: true
  }, React.createElement(ThemeProvider, {
    theme: quizzesTheme
  }, React.createElement(QuizImpl, __assign({}, props)))));
};
export default Quiz;